import {useState} from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {IPersonResponse} from '../../../coreGlobal/models/person'
import {StatusModal} from './StatusModal'
import useAuthorization from '../../../hooks/useAuthorization'
import {useNavigate, useParams} from 'react-router-dom'
import {getVerifyRecurrenceById} from '../../../coreGlobal/_resquest'
import Swal from 'sweetalert2'
import {LoadingSpinner} from '../../../utils/loading/loadingSpinner'
import {IconIsActive} from '../../../components/IconIsActive'

interface IHeaderClient {
  person: IPersonResponse | undefined
}

const HeaderClient = ({person}: IHeaderClient) => {
  const isAuthorizedToUpdate = useAuthorization('persons.update')
  const navigate = useNavigate()
  let {id} = useParams()
  const [showStatusModal, setShowStatusModal] = useState<boolean>(false)
  const [loading, setLoading] = useState(false)

  const getAvatarImg = (person) => {
    if (person?.physicalPerson?.hideAvatar) {
      return 'avatar-neutro.svg'
    }
    switch (person?.physicalPerson?.gender) {
      case 'F':
        return 'avatar-feminino.svg'
      case 'M':
        return 'avatar-masculino.svg'
      default:
        return 'avatar-neutro.svg'
    }
  }

  const get_badge_class = () => {
    let badgeClass = ''
    switch (person?.lastClientHistory?.status.name) {
      case 'Ativo':
        badgeClass = 'success'
        break
      case 'Restrito':
        badgeClass = 'warning'
        break
      default:
        badgeClass = 'danger'
        break
    }
    return badgeClass
  }

  const get_address = () => {
    const mainStateAndCity = person?.addresses?.[0]?.city
    const mainNeighborhood = person?.addresses?.[0]?.neighborhood

    return (
      <>
        {mainStateAndCity?.state.uf} - {mainNeighborhood}
      </>
    )
  }

  const checkRecurrenceStatus = async () => {
    setLoading(true)
    try {
      const data = await getVerifyRecurrenceById(String(id))
      Swal.fire({
        title: data.message,
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secondary',
        },
      })
      setLoading(false)
    } catch (error: any) {
      await Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response.data.message,
        showConfirmButton: true,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          setLoading(false)
        }
      })
    }
  }

  return (
    <>
      {loading ? (
        <LoadingSpinner
          title='Carregando'
          style={{
            width: '2rem',
            height: '2rem',
            colorSpinner: '#f1416c',
            colorText: '#f1416c',
          }}
        />
      ) : (
        <>
          <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
            <div className='me-7 mb-4'>
              <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                <img src={toAbsoluteUrl(`/media/avatars/${getAvatarImg(person)}`)} alt='Metronic' />
                <div
                  className={`position-absolute translate-middle bottom-0 start-100 mb-6 bg-${get_badge_class()} rounded-circle border border-4 border-white h-20px w-20px`}
                ></div>
              </div>
            </div>
            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                <div className='d-flex flex-column'>
                  {person?.physicalPerson?.preferredName ? (
                    <>
                      <div className='d-flex align-items-center mb-1'>
                        <span className='text-gray-800 text-hover-danger fs-2 fw-bolder me-1'>
                          {person?.physicalPerson?.preferredName}
                        </span>
                        <span>
                          <KTIcon iconName='verify' className='fs-1 text-primary' />
                        </span>
                      </div>
                      <div className='d-flex align-items-center mb-2'>
                        <span className='fs-8 me-1'>{person?.name}</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className='d-flex align-items-center mb-1'>
                        {person?.activeAlert && (
                          <IconIsActive text={person?.alerts?.[0]?.observation} />
                        )}

                        <span className='text-gray-800 text-hover-danger fs-2 fw-bolder me-1'>
                          {person?.name}
                        </span>
                      </div>
                    </>
                  )}
                  <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                    <a
                      href='#'
                      className='d-flex align-items-center text-gray-400 text-hover-danger me-5 mb-2'
                    >
                      <KTIcon iconName='profile-circle' className='fs-4 me-1' />
                      {person?.lastClientHistory && (
                        <button
                          style={{
                            margin: 0,
                            border: 'none',
                            backgroundColor: 'transparent',
                          }}
                          onClick={() => setShowStatusModal(true)}
                        >
                          <span className={`badge badge-${get_badge_class()}`}>
                            {person?.lastClientHistory?.status?.name}
                          </span>
                        </button>
                      )}
                    </a>
                    <span className='d-flex align-items-center text-gray-400 text-hover-danger me-5 mb-2'>
                      <KTIcon iconName='geolocation' className='fs-4 me-1' />
                      {get_address()}
                    </span>
                    <span className='d-flex align-items-center text-gray-400 text-hover-danger mb-2'>
                      <KTIcon iconName='sms' className='fs-4 me-1' />
                      {person?.email}
                    </span>
                  </div>
                  <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'></div>
                </div>
                <div className='d-flex my-7'>
                  {isAuthorizedToUpdate && (
                    <button
                      className='btn btn-sm btn-danger hover-scale me-3'
                      onClick={() => navigate(`/people/list/${id}/edit`)}
                    >
                      Editar Cliente
                    </button>
                  )}
                  {person?.lastClientHistory?.status.id == 2 && (
                    <div className='dropdown'>
                      <button
                        className='btn btn-link btn-color-muted btn-active-color-danger'
                        style={{marginTop: '-9px'}}
                        type='button'
                        data-bs-toggle='dropdown'
                        aria-expanded='true'
                      >
                        <i
                          className='ki-duotone ki-dots-square-vertical fs-3x'
                          style={{marginBottom: '-15px'}}
                        >
                          <span className='path1'></span>
                          <span className='path2'></span>
                          <span className='path3'></span>
                          <span className='path4'></span>
                        </i>
                      </button>
                      <ul className='dropdown-menu'>
                        <li>
                          <button className='dropdown-item' onClick={checkRecurrenceStatus}>
                            Consultar restrição
                          </button>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {showStatusModal && (
            <StatusModal
              lastClientHistory={person?.lastClientHistory}
              close={() => setShowStatusModal(false)}
            />
          )}
        </>
      )}
    </>
  )
}

export {HeaderClient}
